// src/components/Header.js
import React, { useContext, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Navbar, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { GoalsContext } from '../State/GoalsContext';
import { goalTypeToUrl } from '../utils/goalTypeUtils';
import HeaderSearch from './HeaderSearch';
import BrowserTranslateHint from './BrowserTranslateHint';
import { BRAND_LOGO_URL } from '../utils/brandAssets';

/** Goal grid only (not goal/target/indicator detail, profile, or contact). */
function isGoalGridHome(pathname) {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  return p === '/un-sdg' || p === '/eu-sdg';
}

/** Goal / target / indicator detail shells (two-column layout). */
function isGoalDetailRoute(pathname) {
  const p = pathname || '';
  return (
    /^\/(un-sdg|eu-sdg)\/goal\//.test(p)
  );
}

const Header = () => {
  const { goalType, setGoalType } = useContext(GoalsContext);
  const location = useLocation();
  const onGoalGridHome = isGoalGridHome(location.pathname);
  const onGoalDetail = isGoalDetailRoute(location.pathname);
  const onPortalRoute =
    location.pathname === '/un-sdg' ||
    location.pathname.startsWith('/un-sdg/') ||
    location.pathname === '/eu-sdg' ||
    location.pathname.startsWith('/eu-sdg/') ||
    location.pathname === '/' ||
    location.pathname.startsWith('/sdg-profile') ||
    location.pathname.startsWith('/profile');

  useEffect(() => {
    const path = location.pathname;

    if (path === '/eu-sdg' || path.startsWith('/eu-sdg/')) {
      if (goalType !== 'eu') setGoalType('eu');
    } else if (path === '/un-sdg' || path.startsWith('/un-sdg/') || path === '/') {
      if (goalType !== 'un') setGoalType('un');
    }
  }, [location.pathname, goalType, setGoalType]);

  const navbarClass = [
    'site-navbar',
    'sticky-top',
    onGoalGridHome ? '' : 'has-back-to-goals',
    onGoalDetail ? 'has-detail-layout' : '',
  ].filter(Boolean).join(' ');

  return (
    <Navbar
      bg="light"
      expand="lg"
      className={navbarClass}
    >
      <Container className="site-navbar__inner">
        {!onGoalGridHome && (
          <Link
            to={`/${goalTypeToUrl(goalType)}`}
            className="back-to-goals-nav page-back-link"
            aria-label="Back to goals"
          >
            <i className="bi bi-chevron-left" aria-hidden="true" />
            Back to Goals
          </Link>
        )}

        <Navbar.Brand
          as={Link}
          to={`/${goalTypeToUrl(goalType)}`}
          className={`site-navbar__brand navbar-brand-logo${onGoalGridHome ? '' : ' navbar-brand-logo-mobile-only'}`}
          aria-label="Go to home"
        >
          <img
            src={BRAND_LOGO_URL}
            alt="ASK Logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="site-navbar__toggle" />

        <Navbar.Collapse id="basic-navbar-nav" className="site-navbar__collapse">
          <div className="site-navbar__right">
            {onPortalRoute ? <HeaderSearch /> : null}
            <BrowserTranslateHint />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
